<template>
  <CustomerCard :jobId="jobId"
                :customer="Customer"
                :address="CustomerAddress"
                :contact="CustomerContact"
                :isOrder="isOrder"
                :fillHeight="false">
  </CustomerCard>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import CustomerCard from "@/views/job/newjob/cards/customer/CustomerCard2.vue";

export default {
  name: "CustomerInvoiceOptionsCard",
  props: {
    jobId: [Number, String],
    customerId: [String, Number],
    addressId: [String, Number],
    contactId: [String, Number],

    customer: Object,
    address: Object,
    contact: Object,

    isOrder: Boolean,
  },
  components: {
    CustomerCard,
  },
  mixins: [clientAPI],

  data() {
    return {
      Customer: null,
      CustomerAddress: null,
      CustomerContact: null,
      loading: false,
    };
  },

  mounted() {
    
    
    
    this.loading = true;
    if (this.customer) {
      this.Customer = this.customer;
      if (this.address) {
        this.CustomerAddress = this.address;
      } else if (this.addressId) {
        this.getAddress();
      }
      if (this.contact) {
        this.CustomerContact = this.contact;
      } else if (this.contactId) {
        this.getContact();
      }
    } else {
      if (this.customerId) {
        this.getCustomer().then(() => {
          if (this.addressId) {
            this.getAddress();
          }
          if (this.contactId) {
            this.getContact();
          }
        });
      }
    }
    this.loading = false;
  },

  methods: {
    async getCustomer() {
      await this.getCustomerById(this.customerId)
        .then((response) => {
          this.Customer = response;

          this.CustomerAddress = this.Customer.DefaultDeliveryAddress;
          this.CustomerContact = this.Customer.DefaultCustomerPerson;
          //console.log("customer", response);
        })
        .catch((e) => {
          console.error(e);
        });
    },

    getAddress() {
      this.getCustomerAdressById(this.addressId)
        .then((response) => {
          this.CustomerAddress = response;
          //console.log("address", response);
        })
        .catch((e) => {
          console.error(e);
        });
    },

    getContact() {
      this.getCustomerContactById(this.contactId)
        .then((response) => {
          this.CustomerContact = response;
          //console.log("contact", response);
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },

  computed: {},

  watch: {
    customerId: function () {
      this.getCustomer();
    },

    addressId: function () {
      this.getAddress();
    },

    contactId: function () {
      this.getContact();
    },

    customer: function (newval) {
      this.Customer = newval;
    },

    address: function (newval) {
      this.CustomerAddress = newval;
    },

    contact: function (newval) {
      this.CustomerContact = newval;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>